<div *ngIf="itemsInputAutoCompletion && itemsInputAutoCompletion.length > 0">
  <ul
    *ngIf="
      inputValue &&
      inputValue.length >= minItemsToDisplayAutocompletion &&
      !hasBeenClickedOn
    "
    class="list-unstyled auto-complete-color mb-0"
  >
    <ng-container *ngFor="let item of itemsInputAutoCompletion; let i = index">
      <li
        class="border border-light p-2 px-1"
        [class.bg-even]="i % 2 === 0"
        (mousedown)="$event.preventDefault()"
        (click)="emitAutoCompletionItem(item)"
      >
        {{ item }}
      </li>
    </ng-container>
  </ul>
  <p
    *ngIf="customMessage"
    class="text-secondary fs-5-personnalize"
    [innerHTML]="customMessage"
  ></p>
</div>
